<div *ngIf="enrollment" class="d-flex flex-column justify-content-center align-items-start h-100 w-100">

    <div class="container-fluid py-3">

        <div *ngIf="enrollment.paymentInfo" class="row mb-3">

            <div *ngIf="!this.enrollment.paid" class="col-12">

                <app-enrollment-payment-redsys
                    class="w-100"
                    [enrollment]="enrollment">
                </app-enrollment-payment-redsys>

            </div>

            <div *ngIf="this.enrollment.paid" class="col-12 bg-primary-color">

                <div class="d-flex flex-row justify-content-start align-items-center h-100 p-2">
                    <fa-icon [icon]="['fas', 'receipt']" class="me-2"></fa-icon>
                    <span>La reserva está pagada</span>
                </div>

            </div>

        </div>

        <!-- Resumen -->
        <div class="w-100">

            <div class="w-100 mb-2">
                <span class="text-primary-color fw-bolder">Resumen</span>
            </div>

            <div class="row mb-3">

                <div class="col-12 col-lg-4">

                    <div class="d-flex flex-column justify-content-center align-items-center w-100 border">
                        <div class="bg-primary-color text-center w-100 p-2">
                            <span class="fs-5">Código de inscripción</span>
                        </div>
                        <div class="text-center w-100 p-2">
                            <span class="fw-bold">{{ enrollment.enrollmentCode }}</span>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-lg-4">
                    <div class="d-flex flex-column justify-content-center align-items-center w-100 border">
                        <div class="bg-primary-color text-center w-100 p-2">
                            <span class="fs-5">Participante</span>
                        </div>
                        <div class="text-center w-100 p-2">
                            <span class="fw-bold">{{ enrollment.studentName }} {{ enrollment.studentSurname }}</span>
                        </div>

                    </div>
                </div>

                <div class="col-12 col-lg-4">
                    <div class="card d-flex flex-column justify-content-center align-items-center w-100 border">
                        <div class="bg-primary-color text-center w-100 p-2">
                            <span class="fs-5">Edición</span>
                        </div>
                        <div class="text-center w-100 p-2">
                            <span class="fw-bold">{{ enrollment.editionDescription }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mb-3">

                <div class="col-12">

                    <table class="table table-bordered">

                        <tbody *ngFor="let class of enrollment.classes">
                            <tr>
                                <td class="bg-accent-lighter-color fw-bold" colspan="3">
                                    <span>{{ class.schedule.description }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Curso</span>
                                </td>
                                <td>
                                    <span>{{ class.courseName }} [{{ class.classification.name }}]</span>
                                </td>
                                <td class="fw-bold text-end">
                                    <span>{{ class.price }} €</span>
                                </td>
                            </tr>
                            <tr *ngFor="let extra of enrollment.extraServices">
                                <td *ngIf="extra.classId == class.classId">
                                    <span>Extra</span>
                                </td>
                                <td *ngIf="extra.classId == class.classId">
                                    <span>{{ extra.extraServiceDisplayName }}</span>
                                </td>
                                <td class="fw-bold text-end" *ngIf="extra.classId == class.classId">
                                    <span>{{ extra.extraServicePrice }} €</span>
                                </td>
                            </tr>
                        </tbody>

                        <tfoot *ngIf="enrollment.paymentInfo">
                            <tr>
                                <td class="bg-primary-lighter-color fw-bold" colspan="3">
                                    <span>Resumen del pago:</span>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <span>Total de los cursos:</span>
                                </td>
                                <td class="fw-bold text-end">
                                    <span>{{enrollment.paymentInfo.totalPriceCourses}} €</span>
                                </td>
                            </tr>
                            <tr *ngIf="enrollment.paymentInfo.discountPriceCourses > 0">
                                <td colspan="2">
                                    <span>Descuento aplicado al curso: </span>
                                </td>
                                <td class="fw-bold text-end">
                                    <span>-{{enrollment.paymentInfo.discountPriceCourses}} €</span>
                                </td>
                            </tr>
                            <tr *ngIf="enrollment.extraServices && enrollment.extraServices.length > 0">
                                <td colspan="2">
                                    <span>Total de los extras:</span>
                                </td>
                                <td class="fw-bold text-end">
                                    <span>{{enrollment.paymentInfo.totalPriceExtras}} €</span>
                                </td>
                            </tr>
                            <tr class="fs-5">
                                <td class="bg-grey-color fw-bold" colspan="2">
                                    <span>TOTAL INSCRIPCIÓN</span>
                                </td>
                                <td class="bg-grey-color fw-bold text-end">
                                    <span>{{enrollment.paymentInfo.finalPriceEnrollment}} €</span>
                                </td>
                            </tr>
                        </tfoot>
                    </table>

                </div>

            </div>

        </div>

        <!-- Autorizaciones -->
        <div class="w-100">

            <div class="w-100 mb-2">
                <span class="text-primary-color fw-bolder">Autorizaciones</span>
            </div>

            <div *ngIf="enrollment.approbations && approbationTypes" class="row mb-3">

                <div class="col-12">

                    <div *ngIf="enrollment.approbations.length == 0" class="bg-accent-color">

                        <div class="d-flex flex-row justify-content-start align-items-center h-100 p-2">
                            <span>No hay autorizaciones aprobadas para esta inscripción.</span>
                        </div>

                    </div>

                    <div *ngIf="enrollment.approbations.length > 0" class="d-flex flex-column justify-content-start align-items-start">

                        <div class="mb-2" *ngFor="let approbationType of approbationTypes">

                            <div class="w-100 mb-2">
                                <span class="fw-bold">Autorizaciones {{approbationType}}:</span>
                            </div>

                            <div *ngFor="let enrollmentApprobation of getApprobationsByType(approbationType)" class="d-flex flex-row justify-content-start align-items-start w-100">

                                <p-checkbox
                                    class="me-2"
                                    [inputId]="enrollmentApprobation.approbationId.toString()"
                                    [binary]="true"
                                    [ngModel]="true"
                                    [readonly]="true">
                                </p-checkbox>

                                <label [for]="enrollmentApprobation.approbationId.toString()">
                                    <span>{{enrollmentApprobation.approbation.text}}</span>
                                </label>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>

</div>
